import {
  // enums
  UTA_MANAGEMENT_ACTIONS_ENUM,
  UTA_MANAGEMENT_SECTION_ENUM,
  UTA_MANAGEMENT_TABS_ENUM,
  UTA_MANAGEMENT_REQUEST_TYPE,
  // configs
  TAP_REQUEST_STATUSES_CONFIG,
  UTA_MANAGEMENT_TABS_SECTIONS_CONFIG,
} from '@/components/pei/ubication-tech-assistance/_config/management';

export const ENUMS = {
  MODE: { request: 'request', management: 'management' },
  ACTIONS: UTA_MANAGEMENT_ACTIONS_ENUM,
  SECTIONS: UTA_MANAGEMENT_SECTION_ENUM,
  TABS: UTA_MANAGEMENT_TABS_ENUM,
  REQUEST_TYPE: UTA_MANAGEMENT_REQUEST_TYPE,
};

export const CONFIG = {
  STATUS: TAP_REQUEST_STATUSES_CONFIG,
  TABS_SECTIONS: UTA_MANAGEMENT_TABS_SECTIONS_CONFIG,
};
